import { RouteConfig } from "vue-router";
import LoginComponent from "@/views/authenticate/login.vue";

export const AUTHENTICATE_ROUTES: RouteConfig[] = [
  {
    path: "/login",
    name: "LoginComponent",
    component: LoginComponent
  }
];